import React, { useState, useEffect } from 'react';
import { otherApi } from '../api';
import { Button, Select, message, Form } from 'antd';

const { Option } = Select;

const VakairaMembersDownload = () => {
  const [vakairaOptions, setVakairaOptions] = useState([]);
  const [subVakairaOptions, setSubVakairaOptions] = useState([]);
  const [selectedVakaira, setSelectedVakaira] = useState(null);
  const [selectedSubVakaira, setSelectedSubVakaira] = useState(null);
  const [vakairaMap, setVakairaMap] = useState(new Map());
  const [subVakairaMap, setSubVakairaMap] = useState(new Map());

  // Fetch Vakaira List
  const fetchDataVakaira = async () => {
    try {
      const response = await otherApi.get('/vakaira');
      if (response.data && Array.isArray(response.data.data)) {
        const vakairaMap = new Map();
        response.data.data.forEach(v => {
          vakairaMap.set(v._id, v.vakairaName || 'Unknown');
        });
        setVakairaOptions(response.data.data.map(v => ({
          value: v._id,
          label: v.vakairaName || 'Unknown'
        })));
        setVakairaMap(vakairaMap);
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('Failed to fetch Vakaira data:', error);
      message.error('Failed to fetch Vakaira data. Please try again later.');
    }
  };

  // Fetch SubVakaira List when a Vakaira is selected
  const fetchDataSubVakaira = async (vakairaId) => {
    try {
      const response = await otherApi.get(`/vakaira/${vakairaId}`);
      if (response.data && response.data.success && Array.isArray(response.data.data.subVakairaName)) {
        const subVakairaMap = new Map();
        response.data.data.subVakairaName.forEach(sv => {
          subVakairaMap.set(sv._id, sv.subVakairaName || 'Unknown');
        });
        setSubVakairaOptions(response.data.data.subVakairaName.map(sv => ({
          value: sv._id,
          label: sv.subVakairaName || 'Unknown'
        })));
        setSubVakairaMap(subVakairaMap);
      } else {
        throw new Error('Unexpected response structure');
      }
    } catch (error) {
      console.error('Failed to fetch Sub-Vakaira data:', error);
      message.error('Failed to fetch Sub-Vakaira data. Please try again later.');
    }
  };

  // Helper function to convert IDs to names
  const convertIdsToNames = (values) => {
    const vakairaName = vakairaMap.get(values.vakairaName) || 'Unknown Vakaira';
    const subVakairaName = subVakairaMap.get(values.subVakairaName) || 'Unknown Sub-Vakaira';
    return {
      vakairaName,
      subVakairaName
    };
  };

  // Handle Vakaira change
  const handleVakairaChange = (value) => {
    setSelectedVakaira(value);
    fetchDataSubVakaira(value); // Fetch Sub-Vakaira when Vakaira changes
  };

  // Handle SubVakaira change
  const handleSubVakairaChange = (value) => {
    setSelectedSubVakaira(value);
  };

  // Fetch and download the PDF
  const downloadPDF = async () => {
    if (!selectedVakaira || !selectedSubVakaira) {
      message.error('Please select both Vakaira and Sub-Vakaira');
      return;
    }

    // Use convertIdsToNames to convert the selected Vakaira and Sub-Vakaira IDs to names
    const selectedValues = { vakairaName: selectedVakaira, subVakairaName: selectedSubVakaira };
    const { vakairaName, subVakairaName } = convertIdsToNames(selectedValues);

    try {
      const response = await otherApi.post('/down/report', {
        vakairaName,
        subVakairaName
      }, {
        responseType: 'blob' // Ensure we receive a blob (binary) response
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${vakairaName}_${subVakairaName}_members.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Failed to download PDF:', error);
      message.error('Failed to download PDF. Please try again later.');
    }
  };

  // Fetch Vakaira data on component mount
  useEffect(() => {
    fetchDataVakaira();
  }, []);

  return (
    <div>
      <h2>Select Vakaira and SubVakaira to Download Members List</h2>
      <Form>
        <Form.Item
          name="vakairaName"
          label="Vakaira"
          rules={[{ required: true, message: 'Please select Vakaira!' }]}
        >
          <Select
            options={vakairaOptions}
            onChange={handleVakairaChange}
            placeholder="Select Vakaira"
          />
        </Form.Item>
        <Form.Item
          name="subVakairaName"
          label="Sub-Vakaira"
          rules={[{ required: true, message: 'Please select Sub-Vakaira!' }]}
        >
          <Select 
            options={subVakairaOptions} 
            onChange={handleSubVakairaChange} 
            placeholder="Select Sub-Vakaira"
          />
        </Form.Item>
      </Form>
      <br />
      <Button type="primary" onClick={downloadPDF}>Download Members PDF</Button>
    </div>
  );
};

export default VakairaMembersDownload;
